// Réduit une photo avant envoi (justificatifs) : les photos d'appareils
// récents (tablettes, smartphones) pèsent plusieurs Mo, ce qui dépasse vite
// la limite d'envoi et alourdit la base. Un justificatif reste parfaitement
// lisible en 2000 px de côté max, en JPEG qualité 85.
//
// Les PDF, GIF et petites images sont renvoyés tels quels. En cas de souci
// (navigateur sans canvas, image illisible...), on renvoie le fichier d'origine.
const MIN_BYTES = 1.5 * 1024 * 1024;
const MAX_SIDE = 2000;
const QUALITY = 0.85;

export const prepareImageForUpload = async (file) => {
  try {
    if (!file || !file.type || !file.type.startsWith('image/') || file.type === 'image/gif') return file;
    if (file.size <= MIN_BYTES) return file;

    // createImageBitmap applique l'orientation EXIF (photos prises en portrait/paysage).
    const bitmap = await createImageBitmap(file);
    const scale = Math.min(1, MAX_SIDE / Math.max(bitmap.width, bitmap.height));
    const width = Math.max(1, Math.round(bitmap.width * scale));
    const height = Math.max(1, Math.round(bitmap.height * scale));

    const canvas = document.createElement('canvas');
    canvas.width = width;
    canvas.height = height;
    const ctx = canvas.getContext('2d');
    ctx.fillStyle = '#ffffff'; // fond blanc (PNG transparents -> JPEG)
    ctx.fillRect(0, 0, width, height);
    ctx.drawImage(bitmap, 0, 0, width, height);
    if (bitmap.close) bitmap.close();

    const blob = await new Promise((resolve) => canvas.toBlob(resolve, 'image/jpeg', QUALITY));
    if (!blob || blob.size >= file.size) return file;

    const baseName = (file.name || 'justificatif').replace(/\.[^.]+$/, '');
    return new File([blob], `${baseName}.jpg`, { type: 'image/jpeg' });
  } catch (err) {
    return file;
  }
};
